import React from "react"
import NumericDisplay from './numericDisplay'

class EnrolmentTracker2 extends React.Component {
  render() {
      return (
          <NumericDisplay endpointFunction={"get_enrolment_count_all_time"} />
      )
  } 
}

export default EnrolmentTracker2
